module.exports = __webpack_public_path__ + "media/assets/social-email-eb0ca7c98386c3e2a806c5160329da92.svg";